import { ReactNode } from 'react';

import { Alert, AlertTitle } from '@mui/material';

export enum AlertTypes {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
}

interface AlertProps {
  children?: ReactNode;
  title?: ReactNode;
  severity?: AlertTypes;
  className?: string;
}

// This template reflects the way we use Alert in this repo and the toucan-design storybook.
export const AlertTemplate = ({ children, title, severity, className }: AlertProps) => (
  <Alert severity={severity} className={className}>
    {title && <AlertTitle>{title}</AlertTitle>}
    {children}
  </Alert>
);
